import { setUser } from "../slices/auth.slice";
import { ENDPOINT, STATUS } from "../../constants/server/api";
import { ERROR_CODES } from "../../constants/server/error";
import { fetchApiData } from "../../utils/apiUtils";

export const login = (email, password) => async (dispatch) => {
  const res = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.SA_USER_ADMIN}/login`,
    data: { email, password },
    dispatch,
    handleAuthResponse: true,
  });

  if (res === ERROR_CODES.NOT_VERIFIED || res === ERROR_CODES.USER_NOT_FOUND) {
    return res;
  }

  if (res) {
    dispatch(setUser({ user: res.user }));
    return STATUS.OK;
  }
};

export const requestPasswordReset = (email) => async (dispatch) => {
  return await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.SA_USER_ADMIN}/reset-password-request`,
    data: { email },
    dispatch,
    useAuth: false,
  });
};

export const resetPassword = (token, password) => async (dispatch) => {
  return await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.SA_USER_ADMIN}/reset-password`,
    data: { token, password },
    dispatch,
    useAuth: false,
  });
};
